import { JobPipelineService } from '../../services/job-pipeline-service';
import { NotificationService } from 'ui-components/services/notification-service';
import { ModalService } from 'ui-components/services/modal-service';
import Global from '../../store/global-selectors';
import { ShowInitialNotificationStep } from './steps/show-initial-notification-step';
import { RequestCanPurchaseLabelStep } from './steps/request-can-purchase-label-step';
import { ProcessCanPurchaseLabelStep } from './steps/process-can-purchase-label-step';
import { GetLabelPrintedStatusStep } from './steps/get-label-printed-status-step';
import { ShowWarningStep } from './steps/show-warning-step';
import { RequestGetFulfillmentsStep } from './steps/request-get-fulfillments-step';
import { FirePrintLabelStep } from './steps/fire-print-label-step';

export const BULK_PRINT_PIPELINE = 'BULK_PRINT_PIPELINE';

const pipeline = [
  ShowInitialNotificationStep,
  RequestCanPurchaseLabelStep,
  ProcessCanPurchaseLabelStep,
  GetLabelPrintedStatusStep,
  ShowWarningStep,
  RequestGetFulfillmentsStep,
  FirePrintLabelStep,
];

JobPipelineService.registerPipeline(BULK_PRINT_PIPELINE, {
  pipeline,
  initialData: {},
  onExit: (jobId, state) => {
    const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
    const { notificationId, modalId } = jobData;
    if (notificationId) {
      NotificationService.removeNotification(notificationId);
    }
    if (modalId) {
      ModalService.closeModalById(modalId);
    }
  },
});
